@let curModel = model();
@let homePageCard = curModel?.homePageCard;

@if (!!curModel?.picture) {
    <div
        class="overflow-hidden"
        [ngClass]="{
            'aspect-square md:aspect-21/9 md:rounded-2xl': homePageCard,
            'aspect-3/2 rounded-2xl md:aspect-30/9': !homePageCard,
        }">
        <big-ui-picture [model]="model()?.picture" />
    </div>
} @else {
    @if (!!curModel?.title) {
        <h1
            [class]="headingSize()"
            class="only:mb-0">
            {{ curModel?.title }}
        </h1>
    }

    <ng-content></ng-content>
}

@if (homePageCard) {
    <div
        class="relative mx-4 -mt-12 max-h-[calc(100%_-_(var(--spacing)_*_12))] md:absolute md:right-auto md:bottom-6 md:left-6 md:mx-0 md:mt-0 md:w-[320px] lg:w-[400px]">
        <div class="bg-primary-500 flex flex-col gap-4 rounded-2xl p-6 text-white">
            @if (homePageCard?.label) {
                <big-ui-tag class="self-start">{{ homePageCard.label }}</big-ui-tag>
            }

            @if (homePageCard?.title) {
                <h2 class="mb-0 text-current not-last:-mb-2">{{ homePageCard.title }}</h2>
            }

            @if (homePageCard.content) {
                <p class="mb-0">{{ homePageCard?.content }}</p>
            }

            @let linkUrl = homePageCard.linkUrl;
            @if (linkUrl) {
                <big-ui-link
                    [href]="linkUrl"
                    [linkClass]="'primary flex items-center gap-2 after:absolute after:inset-0 z-(--z-page-title) text-body'"
                    class="self-start">
                    <span>{{ homePageCard?.linkTitle }}</span>
                    <big-icon
                        [icon]="iconArrowRight"
                        [size]="'w-5'"
                        class="fill-current" />
                </big-ui-link>
            }
        </div>
    </div>
}
